import { stateStrategy, translateStateStrategy } from "../constants/stateStrategy.constant";
import { PrivateCompanyLeadData } from "../types/privateCompanyLead";

export const privateCompanyLeadsTransformer = (clients: PrivateCompanyLeadData[]) => {
  return clients
  .map((client) => ({...client, state: stateStrategy[client.state]}))
  .reduce((acc, curr) => ({...acc, [curr.state]: [...(acc[curr.state]), curr]}), {
    registered: [],
    qualifying: [],
    quoting: [],
    negotiating: [],
    completed: []
  })
}

export const privateCompanyLeadsQuickSearchModelTransformer = () => {
  return (clients: PrivateCompanyLeadData[]) => {
    return clients.map((client) => ({
      route: `/private-clients/${client.id}/edit`,
      items: [
        ['Nome da empresa', client.display_name],
        ['Etapa', translateStateStrategy[stateStrategy[client.state]]],
        ['Descrição', client.last_state_change_log?.message],
      ]
    }));
  };
}
